import {
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAILURE,
} from "../constants/customerConstant.js";

//About Reducer
const accountIntialState = {
  home: null,
  profile: null,
  watchlist: null,
  loading: false,
  error: null,
};

export const accountReducer = (state = accountIntialState, action) => {
  switch (action.type) {
    case GET_PROFILE_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload };
    case GET_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_CUSTOMER_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_CUSTOMER_SUCCESS:
      return { ...state, loading: false, customer: action.payload };
    case DELETE_CUSTOMER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
